import { render, staticRenderFns } from "./Map3DPotree.vue?vue&type=template&id=2a0c0985&scoped=true&"
import script from "./Map3DPotree.vue?vue&type=script&lang=js&"
export * from "./Map3DPotree.vue?vue&type=script&lang=js&"
import style0 from "./Map3DPotree.vue?vue&type=style&index=0&id=2a0c0985&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c0985",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
